import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { logoutFromApp } from 'src/common/config/FunctionHelper';
import { removeLocalSeoAllStorage } from 'src/common/config/FunctionHelperPartTwo';
import { cleanupInitialState } from 'src/redux/counterSlice';
import { userCleanupInitialState } from 'src/redux/userReducer';
import { siteAuditCleanupInitialState } from 'src/redux/siteAuditReducer';
import { cleanupKeywordInitialState } from 'src/redux/keywordResearch';
import { cleanupLocalSeoInitialState } from 'src/redux/localSeo';
import { sseService } from 'src/common/services/sseService';
import { posthogService } from 'src/common/services/posthogService';

/**
 * Returns a stable async callback that performs a full user logout:
 * ends the SSE connection, clears all Redux slices,
 * clears the React Query cache, removes persisted flags,
 * and resets the analytics identity.
 */
export const useLogout = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await logoutFromApp();
    posthogService.reset()
    sseService.unsubscribe('app');
    sseService.disconnectAll();
    removeLocalSeoAllStorage();
    try {
      localStorage.removeItem('hideUpgradePricingModal');
    } catch {}
    dispatch(cleanupInitialState());
    dispatch(userCleanupInitialState());
    dispatch(siteAuditCleanupInitialState());
    dispatch(cleanupKeywordInitialState());
    dispatch(cleanupLocalSeoInitialState());
    queryClient.clear();
    if (window.clarity) {
      window.clarity('identify', null);
    }
  }, [dispatch, queryClient]);
};
